import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import {
  DeleteOutlined,
  EditOutlined,
  FilePdfOutlined,
  IdcardOutlined,
  MoreOutlined,
  PlusOutlined,
  StopOutlined,
} from "@ant-design/icons";

import {
  Button,
  Card,
  Checkbox,
  Dropdown,
  Empty,
  Image,
  Input,
  InputNumber,
  Modal,
  Skeleton,
  Space,
  Table,
  Tag,
} from "antd";

import img3 from "../../images/3month.png";
import img6 from "../../images/6manth.png";
import { getColumnSearchProps, fetchData } from "../utils.js";

const CONN_KEY = process.env.REACT_APP_NOT_SECRET_CODE_R;

function App() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [isModalopen, setIsModalopen] = useState(false);
  const [isModalopenApp, setIsModalopenApp] = useState(false);
  const [isModalopenBalance, setIsModalopenBalance] = useState(false);
  const [isModalopenTime, setIsModalopenTime] = useState(false);

  const [staffOutReason, setStaffOutReason] = useState("");
  const [App_reasin, setApp_reasin] = useState("");
  const [staffOutDate, setStaffOutDate] = useState("");
  const [Balance, setBalance] = useState("");

  const staffOutReasonInputRef = useRef(null);
  const BlockAppRef = useRef(null);
  const BalanceInputRef = useRef(null);

  const [selectedRecord, setSelectedRecord] = useState(null);

  const [pin, setPin] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const pinInputRef = useRef(null);

  const [cardId, setCardId] = useState("");

  const [checkedList, setCheckedList] = useState([
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "14",
    "18",
    "19",
  ]);

  const [permissions, setPermissions] = useState({});

  const navigate = useNavigate();

  // ---------- Permissions ----------
  useEffect(() => {
    try {
      const storedPermissions = JSON.parse(localStorage.getItem("permissions"));
      if (storedPermissions?.length) setPermissions(storedPermissions[0]);
    } catch (e) {
      console.warn("permissions parse error:", e);
    }
  }, []);

  const canSeeSectionsGuidesAz = permissions.GuidesAz === 1;
  const canSeeSectionsGuidesAzBalance = permissions.GuidesAzBalance === 1;
  const canSeeSectionsGuidesAzBlock = permissions.GuidesAzBlock === 1;
  const canSeeSectionsGuidesAzUnblock = permissions.GuidesAzUnblock === 1;
  const canSeeSectionsGuidesAzDelete = permissions.GuidesAzDelete === 1;
  const canSeeSectionsGuidesAzEdit = permissions.GuidesAzEdit === 1;
  const canSeeSectionsGuidesAzBlockApp = permissions.GuidesAzBlockApp === 1;

  // ---------- Fetch + format ----------
  const loadTable = async () => {
    try {
      const result = await fetchData();

      const formatted = (result || []).map((item) => {
        let loggedInDevices = item.loggedInDevices;

        // təhlükəsiz parse: JSON deyilsə boş object qoy
        if (typeof loggedInDevices === "string") {
          const s = loggedInDevices.trim();
          if (s.startsWith("{") || s.startsWith("[")) {
            try {
              loggedInDevices = JSON.parse(s);
            } catch {
              loggedInDevices = {};
            }
          } else {
            loggedInDevices = {};
          }
        }

        return {
          ...item,
          key: item.id ?? item.userid, // table üçün key
          loggedInDevices: loggedInDevices || {},
        };
      });

      setData(formatted);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadTable();

    // refresh hər 10 saniyə
    const interval = setInterval(() => {
      loadTable();
    }, 10000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------- Actions ----------
  const showDeleteConfirm = (record) => {
    setItemToDelete(record);
    setOpenDelete(true);
    setPin("");
    setTimeout(() => pinInputRef.current?.focus?.(), 50);
  };

  const handleCartButtonClick = (record) => {
    setSelectedRecord(record);
    setIsModalopenTime(true);
    setCardId("");
  };

  const handleBlock = (record) => {
    setSelectedRecord(record);
    setStaffOutReason("");
    setStaffOutDate("");
    setIsModalopen(true);
    setTimeout(() => staffOutReasonInputRef.current?.focus?.(), 50);
  };

  const handleBlockApp = (record) => {
    setSelectedRecord(record);
    setApp_reasin("");
    setIsModalopenApp(true);
    setTimeout(() => BlockAppRef.current?.focus?.(), 50);
  };

  const handleBalance = (record) => {
    setSelectedRecord(record);
    setBalance("");
    setIsModalopenBalance(true);
    setTimeout(() => BalanceInputRef.current?.focus?.(), 50);
  };

  const handleUnBlock = (record) => {
    Modal.confirm({
      title: "Diqqət",
      content: "Bu Bələdçini Blokunu qaldırmaq istədiyinizə əminsiniz?",
      okText: "Bloku qaldır",
      okType: "danger",
      cancelText: "Ləğv et",
      onOk: async () => {
        try {
          const formData = new FormData();
          formData.append("userid", record.userid);

          const username = localStorage.getItem("username");
          if (username) formData.append("username", username);

          await axios.post(`${CONN_KEY}Unblock.php`, formData);
          loadTable();
        } catch (error) {
          console.error(error);
          Modal.error({ title: "Xəta", content: "Unblock alınmadı." });
        }
      },
    });
  };

  // ---------- Modal submits ----------
  const handleModalSubmit = async () => {
    if (!selectedRecord?.userid) return;

    try {
      await axios.post(`${CONN_KEY}BlockSeb.php`, {
        userid: selectedRecord.userid,
        BlockSeb: staffOutReason,
        BlockSebdate: staffOutDate,
      });
      setIsModalopen(false);
      loadTable();
    } catch (error) {
      console.error(error);
      Modal.error({ title: "Xəta", content: "Block alınmadı." });
    }
  };

  const handleModalSubmitApp = async () => {
    if (!selectedRecord?.userid) return;

    try {
      await axios.post(`${CONN_KEY}BlockRezerv.php`, {
        userid: selectedRecord.userid,
        App_reasin: App_reasin,
      });
      setIsModalopenApp(false);
      loadTable();
    } catch (error) {
      console.error(error);
      Modal.error({ title: "Xəta", content: "BlockApp alınmadı." });
    }
  };

  const handleModalSubmitBalance = async () => {
    if (!selectedRecord?.userid) return;

    try {
      await axios.post(`${CONN_KEY}BalanceUpdate.php`, {
        userid: selectedRecord.userid,
        Balance: Balance,
      });
      setIsModalopenBalance(false);
      loadTable();
    } catch (error) {
      console.error(error);
      Modal.error({ title: "Xəta", content: "Balans update alınmadı." });
    }
  };

  const handleDelete = async () => {
    try {
      if (pin !== "0102") {
        Modal.error({ title: "Error", content: "Incorrect PIN. Item not deleted." });
        return;
      }

      if (!itemToDelete?.userid) return;

      const response = await axios.delete(`${CONN_KEY}Add.php?userid=${itemToDelete.userid}`);

      // burda səndə logic tərsinə idi — düzəldirəm:
      if (response.status === 200) {
        Modal.success({ title: "Success", content: "Product deleted successfully." });
        loadTable();
      } else {
        Modal.error({ title: "Error", content: "Delete alınmadı." });
      }
    } catch (error) {
      console.error(error);
      Modal.error({ title: "Error", content: "An error occurred while deleting." });
    } finally {
      setOpenDelete(false);
      setItemToDelete(null);
      setPin("");
    }
  };

  // ---------- Card click ----------
  const handleCardClick = async (months) => {
    if (!selectedRecord?.userid) return;

    if (!cardId.trim()) {
      Modal.error({ title: "Diqqət !", content: "Etibarlı Kart ID-ni daxil edin." });
      return;
    }

    try {
      const response = await axios.post(
        `${CONN_KEY}timerbuy.php?userid=${selectedRecord.userid}&cardId=${months}&kardId=${cardId}`
      );

      if (response.data?.status === 1) {
        Modal.success({
          title: "Uğur!",
          content: `Kart ${months} aya yeniləndi.`,
          onOk: () => navigate(`/Cart/${selectedRecord.userid}`),
        });

        setIsModalopenTime(false);
        setCardId("");
        loadTable();
      } else {
        Modal.error({
          title: "Xəta!",
          content: response.data?.message || "Kart yenilənmədi.",
        });
      }
    } catch (error) {
      console.error(error);
      Modal.error({ title: "Xəta!", content: "Kart yenilənmədi. Xəta baş verdi." });
    }
  };

  // ---------- Dropdown actions (FIX) ----------
  const renderActions = (_text, record) => {
    if (!record?.key) return null;

    // permissions yoxdursa yönləndir
    if (!canSeeSectionsGuidesAz) {
      navigate("/");
      return null;
    }

    const items = [
      canSeeSectionsGuidesAzDelete && { key: "delete", label: "Delete", icon: <DeleteOutlined /> },
      canSeeSectionsGuidesAzEdit && { key: "edit", label: "Edit", icon: <EditOutlined /> },
      canSeeSectionsGuidesAzBalance && { key: "balance", label: "Balance Update", icon: <PlusOutlined /> },
      canSeeSectionsGuidesAzBlockApp && { key: "blockapp", label: "BlockApp", icon: <StopOutlined /> },
      canSeeSectionsGuidesAzBlock && { key: "block", label: "Block", icon: <StopOutlined /> },
      canSeeSectionsGuidesAzUnblock && { key: "unblock", label: "Unblock", icon: <StopOutlined /> },
    ].filter(Boolean);

    const onClick = ({ key }) => {
      if (key === "delete") return showDeleteConfirm(record);
      if (key === "edit") return navigate(`/Update/${record.userid}`);
      if (key === "balance") return handleBalance(record);
      if (key === "blockapp") return handleBlockApp(record);
      if (key === "block") return handleBlock(record);
      if (key === "unblock") return handleUnBlock(record);
    };

    return (
      <Dropdown menu={{ items, onClick }} placement="bottomRight" trigger={["click"]}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
    );
  };

  // ---------- Columns ----------
  const columns = useMemo(() => {
    return [
      {
        title: "Şəxsiyyət Vəsiqəsi",
        dataIndex: "fileSH",
        key: "20",
        width: 80,
        render: (imagePath, record) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {record.Status && (
              <div className="blockicondfaa dark:bg-slate-800">
                <StopOutlined style={{ color: "red", fontSize: 24, position: "absolute", zIndex: 11111 }} />
              </div>
            )}
            <Image
              className={`imgpp ${record.Status ? "grayscale" : ""}`}
              src={`${CONN_KEY}scan/${imagePath}`}
              alt="filePP"
              style={{ zIndex: 30 }}
            />
          </div>
        ),
      },
      {
        title: "3x4",
        dataIndex: "filePP",
        key: "1",
        width: 80,
        render: (imagePath, record) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {record.Status && (
              <div className="blockicondfaa dark:bg-slate-800">
                <StopOutlined style={{ color: "red", fontSize: 24, position: "absolute", zIndex: 11111 }} />
              </div>
            )}
            <Image
              className={`imgpp ${record.Status ? "grayscale" : ""}`}
              src={`${CONN_KEY}3x4/${imagePath}`}
              alt="filePP"
              style={{ zIndex: 30 }}
            />
          </div>
        ),
      },
      {
        title: "V.Nömrəs",
        dataIndex: "userid",
        key: "2",
        width: 130,
        sorter: {
          compare: (a, b) => {
            const aV = a.userid != null ? a.userid.toString() : "";
            const bV = b.userid != null ? b.userid.toString() : "";
            const na = parseFloat(aV);
            const nb = parseFloat(bV);
            if (!isNaN(na) && !isNaN(nb)) return na - nb;
            return aV.localeCompare(bV);
          },
          multiple: 2,
        },
        render: (value) => <h3 className="bold">{value}</h3>,
        ...getColumnSearchProps("userid"),
      },
      {
        title: "Adı",
        dataIndex: "username",
        width: 130,
        key: "3",
        ...getColumnSearchProps("username"),
      },
      {
        title: "Soy ad",
        width: 150,
        dataIndex: "surename",
        key: "4",
        ...getColumnSearchProps("surename"),
      },
      {
        title: "Doğum günü",
        width: 150,
        dataIndex: "datebhrd",
        key: "26",
        ...getColumnSearchProps("datebhrd"),
      },
      {
        title: "Ata adı",
        dataIndex: "dadname",
        width: 150,
        key: "5",
        ...getColumnSearchProps("dadname"),
      },
      {
        title: "Telefon",
        dataIndex: "Phone",
        width: 150,
        key: "6",
        ...getColumnSearchProps("Phone"),
      },
      {
        title: "Fin",
        dataIndex: "Fin",
        width: 100,
        key: "7",
        ...getColumnSearchProps("Fin"),
      },
      {
        title: "Vəzifəsi",
        dataIndex: "vezife",
        width: 150,
        key: "8",
        sorter: (a, b) => (a.vezife < b.vezife ? -1 : a.vezife > b.vezife ? 1 : 0),
      },
      {
        title: "Status",
        dataIndex: "APPaktive",
        key: "9",
        width: 95,
        render: (text) => (text ? <Tag color="green">Registred</Tag> : <Tag color="red">Not yet</Tag>),
      },
      {
        title: "Balans",
        dataIndex: "Balance",
        width: 100,
        key: "10",
        sorter: (a, b) => (a.Balance < b.Balance ? -1 : a.Balance > b.Balance ? 1 : 0),
      },
      {
        title: "Blok Səbəbi",
        dataIndex: "App_reasin",
        width: 100,
        key: "11",
        sorter: (a, b) => (a.App_reasin < b.App_reasin ? -1 : a.App_reasin > b.App_reasin ? 1 : 0),
      },
      {
        title: "Blok Open",
        dataIndex: "App_openData",
        width: 100,
        key: "12",
        sorter: (a, b) => (a.App_openData < b.App_openData ? -1 : a.App_openData > b.App_openData ? 1 : 0),
      },
      {
        title: "Status",
        dataIndex: "Status",
        key: "13",
        width: 95,
        render: (text) => {
          let tagColor = "blue";
          let statusText = text || "Unknown";
          if (text === "Block") {
            tagColor = "red";
            statusText = "Blocked";
          } else if (!text) {
            tagColor = "green";
            statusText = "Aktiv";
          }
          return <Tag color={tagColor}>{statusText}</Tag>;
        },
      },
      {
        title: "Bitmə tarixi",
        dataIndex: "endtime",
        width: 120,
        key: "14",
        ...getColumnSearchProps("endtime"),
      },
      {
        title: "ölkə",
        dataIndex: "Country",
        width: 130,
        key: "15",
        sorter: (a, b) => (a.Country < b.Country ? -1 : a.Country > b.Country ? 1 : 0),
      },
      {
        title: "Action",
        dataIndex: "userid",
        key: "18",
        width: 80,
        render: (_text, record) => (
          <Space>
            <Button
              className={`ColorMain ${record.Status ? "ccolorblock" : ""}`}
              icon={<IdcardOutlined />}
              onClick={() => handleCartButtonClick(record)}
            />
            <Link to={`/PDF/${record.userid}`} target="_blank" rel="noreferrer">
              <Button className={`ColorMain ${record.Status ? "ccolorblock" : ""}`} icon={<FilePdfOutlined />} />
            </Link>
          </Space>
        ),
      },
      {
        title: "More",
        dataIndex: "userid",
        fixed: "right",
        key: "19",
        render: renderActions,
        width: 70,
      },
    ];
  }, [
    canSeeSectionsGuidesAz,
    canSeeSectionsGuidesAzBalance,
    canSeeSectionsGuidesAzBlock,
    canSeeSectionsGuidesAzBlockApp,
    canSeeSectionsGuidesAzDelete,
    canSeeSectionsGuidesAzEdit,
    canSeeSectionsGuidesAzUnblock,
  ]);

  const filteredColumns = useMemo(
    () => columns.filter((c) => checkedList.includes(c.key)),
    [columns, checkedList]
  );

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : data.length > 0 ? (
        <div className="dark:bg-slate-800">
          {/* Delete Confirm */}
          <Modal
            title="Confirm Deletion"
            open={openDelete}
            onOk={handleDelete}
            onCancel={() => {
              setOpenDelete(false);
              setItemToDelete(null);
              setPin("");
            }}
          >
            <p>
              Bu Bələdçini silmək istədiyinizə əminsiniz? Bu əməliyyat geri qaytarıla bilməz.
              Elementin silinməsini təsdiqləmək üçün PİN kodunuzu daxil edin:
            </p>
            <Input
              ref={pinInputRef}
              type="password"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
            />
          </Modal>

          {/* Column selector */}
          <Checkbox.Group
            value={checkedList}
            onChange={setCheckedList}
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 8,
              marginBottom: 12,
            }}
          >
            {columns.map((column) => (
              <Checkbox key={column.key} value={column.key}>
                {column.title}
              </Checkbox>
            ))}
          </Checkbox.Group>

          <Table
            columns={filteredColumns}
            dataSource={data}
            loading={isLoading}
            pagination={{
              pageSize: 8,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
            }}
            locale={{
              emptyText: (
                <Empty
                  description="No Data"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  style={{ marginTop: 50 }}
                />
              ),
            }}
            rowClassName={(record) => (record.Status ? "disabled" : "")}
          />

          {/* Block App */}
          <Modal
            title="Block app"
            open={isModalopenApp}
            onOk={handleModalSubmitApp}
            onCancel={() => setIsModalopenApp(false)}
            destroyOnClose
          >
            <Input
              ref={BlockAppRef}
              placeholder="Reason"
              name="App_reasin"
              value={App_reasin}
              onChange={(e) => setApp_reasin(e.target.value)}
            />
          </Modal>

          {/* Block */}
          <Modal
            title="Block"
            open={isModalopen}
            onOk={handleModalSubmit}
            onCancel={() => setIsModalopen(false)}
            destroyOnClose
          >
            <Space style={{ width: "100%" }} direction="vertical">
              <Input
                ref={staffOutReasonInputRef}
                placeholder="Reason"
                name="BlockSeb"
                value={staffOutReason}
                onChange={(e) => setStaffOutReason(e.target.value)}
              />
              <Input
                placeholder="Date"
                name="BlockSebdate"
                value={staffOutDate}
                onChange={(e) => setStaffOutDate(e.target.value)}
              />
            </Space>
          </Modal>

          {/* Balance */}
          <Modal
            title="Balans Update"
            open={isModalopenBalance}
            onOk={handleModalSubmitBalance}
            onCancel={() => setIsModalopenBalance(false)}
            destroyOnClose
          >
            <InputNumber
              ref={BalanceInputRef}
              placeholder="500"
              value={Balance}
              onChange={(v) => setBalance(v ?? "")}
              style={{ width: "100%" }}
            />
          </Modal>

          {/* Card time */}
          <Modal
            title="Kart Müddətini Seçin"
            open={isModalopenTime}
            onCancel={() => setIsModalopenTime(false)}
            footer={null}
          >
            <Input
              placeholder="Kart ID-ni daxil edin"
              type="password"
              value={cardId}
              onChange={(e) => setCardId(e.target.value)}
              style={{ marginBottom: 20 }}
            />

            <div style={{ display: "flex", gap: 12 }}>
              <Card hoverable onClick={() => handleCardClick(3)} style={{ width: "50%" }}>
                <img src={img3} alt="3 Ay" style={{ width: "100%" }} />
              </Card>
              <Card hoverable onClick={() => handleCardClick(6)} style={{ width: "50%" }}>
                <img src={img6} alt="6 Ay" style={{ width: "100%" }} />
              </Card>
            </div>

            {selectedRecord?.userid && (
              <Link to={`/Cart/${selectedRecord.userid}`}>
                <Button
                  type="primary"
                  icon={<IdcardOutlined />}
                  style={{ marginTop: 20, width: "100%" }}
                >
                  Kart - {selectedRecord.userid}
                </Button>
              </Link>
            )}
          </Modal>
        </div>
      ) : (
        <div>
          <p>No data found.</p>
          <Empty />
          <Button type="primary" className="ColorMain dark:bg-slate-900">
            <Link to="/add">Add</Link>
          </Button>
        </div>
      )}
    </>
  );
}

export default App;
